import { useEffect, useRef } from 'react';
import { animate, useMotionValue, useReducedMotion, useTransform, motion } from 'framer-motion';

/** Count-up numeral for KPI cards. Respects prefers-reduced-motion. */
export function AnimatedNumber({ value, format }: { value: number; format?: (n: number) => string }) {
  const reduced = useReducedMotion();
  const mv = useMotionValue(reduced ? value : 0);
  const fmtRef = useRef(format);
  fmtRef.current = format;
  const text = useTransform(mv, (v) => (fmtRef.current ? fmtRef.current(v) : String(Math.round(v))));

  useEffect(() => {
    if (reduced) {
      mv.set(value);
      return;
    }
    const controls = animate(mv, value, { duration: 0.9, ease: [0.22, 1, 0.36, 1] });
    return () => controls.stop();
  }, [value, reduced, mv]);

  return <motion.span>{text}</motion.span>;
}
